import { useTranslation } from 'react-i18next';
import { Badge } from '@bliks-io/ui';

export function BetaBadge() {
  const { t } = useTranslation();

  return (
    <Badge colorScheme="warning" size="sm">
      {t('common.Beta')}
    </Badge>
  );
}
